import React, { FC } from 'react';

import UserPrimaryContact from 'buyside/components/presentation/MainSiteNavigation/TopNavigation/NavigationUser/NavigationUserInfo/Sections/userPrimaryContact';
import UserRanking from 'buyside/components/presentation/MainSiteNavigation/TopNavigation/NavigationUser/NavigationUserInfo/Sections/userRanking';
import UserAccess from 'buyside/components/presentation/MainSiteNavigation/TopNavigation/NavigationUser/NavigationUserInfo/Sections/userAccess';

import { NavigationUserInfoQuery, useNavigationUserInfoQuery } from 'interfaces/graphql-typings';

import styles from './navigationUserInfoStyles.scss';

const accessData = (
  currentUser: NavigationUserInfoQuery['currentUser'],
  accessType: string
): any => ({
  type: 'product',
  isBlocked: currentUser?.[`${accessType}IsBlocked` as keyof typeof currentUser],
  daysRemaining: currentUser?.[`${accessType}DaysLeft` as keyof typeof currentUser]
});

const quotaData = (
  paladin: NonNullable<NavigationUserInfoQuery['currentUser']>['paladin'],
  quotaType: string
): any => ({
  type: 'paladin',
  quota: `${paladin?.[`${quotaType}CurrentMonth` as keyof typeof paladin]}/${
    paladin?.[`${quotaType}Quota` as keyof typeof paladin]
  }`,
  percentRemaining: paladin?.[`${quotaType}Percent` as keyof typeof paladin],
  quotaDeadline: paladin?.nextQuotaDeadline
});

const NavigationUserInfo: FC<{
  canWriteIdeas: boolean;
}> = ({ canWriteIdeas }) => {
  const { data } = useNavigationUserInfoQuery();

  const currentUser = data?.currentUser;

  if (!currentUser) return null;

  const { paladin, featuredRank, primaryContact, isPaladin } = currentUser;

  return (
    <>
      <div className={styles.navigationUserInfo}>
        <div className={styles.navigationUserInfoColumn}>
          <UserAccess
            accessData={(accessType: string) => accessData(currentUser, accessType)}
            canWriteIdeas={canWriteIdeas}
            hasPollAnswerQuota={Boolean(paladin?.hasPollAnswerQuota)}
            isPaladin={isPaladin}
            quotaData={(quotaType: string) => quotaData(paladin, quotaType)}
          />
        </div>
        <div className={styles.navigationUserInfoColumn}>
          {featuredRank ? <UserRanking featuredRank={featuredRank} /> : null}
          {primaryContact ? <UserPrimaryContact primaryContact={primaryContact} /> : null}
        </div>
      </div>
    </>
  );
};

export default NavigationUserInfo;
